import React, { useEffect, useState } from "react";

import { ReactComponent as GrowthIcon } from "../../../assets/icons/growth.svg";
import { ReactComponent as CharacterIcon } from "../../../assets/icons/character.svg";
import { ReactComponent as FellowshipIcon } from "../../../assets/icons/fellowship.svg";
import { ReactComponent as ServiceIcon } from "../../../assets/icons/service.svg";
import { ReactComponent as VictoryIcon } from "../../../assets/icons/victory.svg";
import { ReactComponent as WeightIcon } from "../../../assets/icons/weigh.svg";

import { ReactComponent as WhiteGrowthIcon } from "../../../assets/icons/white_growth.svg";
import { ReactComponent as WhiteWeightIcon } from "../../../assets/icons/white_weight.svg";
import { ReactComponent as WhiteFellowshipIcon } from "../../../assets/icons/white_fellowship.svg";
import { ReactComponent as WhiteVictoryIcon } from "../../../assets/icons/white_victory.svg";
import { ReactComponent as WhiteCharacterIcon } from "../../../assets/icons/white_character.svg";
import { ReactComponent as WhiteServiceIcon } from "../../../assets/icons/white_service.svg";

import { ReactComponent as BluePlus } from "../../../assets/icons/bluePlus.svg";
import { ReactComponent as PurplePlus } from "../../../assets/icons/purplePlus.svg";
import { ReactComponent as YellowPlus } from "../../../assets/icons/yellowPlus.svg";
import { ReactComponent as PinkPlus } from "../../../assets/icons/pinkPlus.svg";
import { ReactComponent as GreenPlus } from "../../../assets/icons/greenPlus.svg";

import { ReactComponent as BlueGreenPlus } from "../../../assets/icons/bluGreenPlus.svg";

import { ReactComponent as CloseIcon } from "../../../assets/icons/closeIcon.svg";

interface Benefit {
  order: number;
  topIcon: JSX.Element;
  title: string;
  description: string;
  bottomIcon: JSX.Element;
  backgroundColor?: string;
  scripture?: string;
  flipIcon?: JSX.Element;
}

const components = [
  {
    order: 1,
    topIcon: <GrowthIcon />,
    bottomIcon: <BluePlus />,
    backgroundColor: "#5764EB",
    flipIcon: <WhiteGrowthIcon />,
  },
  {
    order: 2,
    topIcon: <ServiceIcon />,
    bottomIcon: <PinkPlus />,
    backgroundColor: "#FF5C7B",
    flipIcon: <WhiteServiceIcon />,
  },
  {
    order: 3,
    topIcon: <VictoryIcon />,
    bottomIcon: <BlueGreenPlus />,
    backgroundColor: "#30B0C7",
    flipIcon: <WhiteVictoryIcon />,
  },
  {
    order: 4,
    topIcon: <WeightIcon />,
    bottomIcon: <YellowPlus />,
    backgroundColor: "#E59D22",
    flipIcon: <WhiteWeightIcon />,
  },
  {
    order: 5,
    topIcon: <CharacterIcon />,
    bottomIcon: <GreenPlus />,
    backgroundColor: "#02C7BE",
    flipIcon: <WhiteCharacterIcon />,
  },
  {
    order: 6,
    topIcon: <FellowshipIcon />,
    bottomIcon: <PurplePlus />,
    backgroundColor: "#B051DE",
    flipIcon: <WhiteFellowshipIcon />,
  },
]

const BenefitsOfCBR: React.FC = () => {


  const [fullBenefits, setFullBenefits] = useState<Benefit[]>([
    {
      order: 1,
      topIcon: <GrowthIcon />,
      title: "string",
      description: "string",
      bottomIcon: <BluePlus />,
      backgroundColor: "#5764EB",
      scripture: "string",
      flipIcon: <WhiteGrowthIcon />,
    }
  ])

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "/api/homepage-benefits?populate=*", {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.data) {
          const fetchedBenefits = data.data;
          const merged: Record<number, any> = {};

          // Initialize with static components
          components.forEach((item) => {
            merged[item.order] = { ...item };
          });

          // Merge with fetched data
          fetchedBenefits.forEach((item: any) => {
            if (merged[item.order]) {
              merged[item.order] = {
                ...merged[item.order],
                ...item,
              };
            } else {
              merged[item.order] = item;
            }
          });

          setFullBenefits(Object.values(merged));
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const [flippedCards, setFlippedCards] = useState<Record<number, boolean>>({});

  const toggleCard = (id: number): void => {
    setFlippedCards((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div className="container mx-auto my-20  ">
      <div className="text-center mb-10">
        <p className="text-lighterYellow font-medium text-xl mb-1">
          Broad Benefits of CBR
        </p>
        <h1 className="text-gray-900 font-medium text-2xl">
          What do you gain by doing the Consistent Bible Reading Course?
        </h1>
      </div>

      <div className="flex flex-wrap gap-6 items-stretch justify-center lg:justify-between">
        {fullBenefits.map((benefit) => {
          const isFlipped = flippedCards[benefit.order] || false;
          return (

            <div
              className={`w-[327px] lg:w-[30%] border shadow rounded-3xl p-6 flex flex-col items-center transition-transform ${isFlipped
                ? "transform rotate-y-180 shadow-lg shadow-white"
                : "shadow"
                }`}
              key={benefit.order}
              style={{
                backgroundColor: isFlipped
                  ? benefit.backgroundColor
                  : "white",
              }}
            >
              {isFlipped ? (
                <div className="flex flex-col items-center justify-center h-full ">
                  <div className=" mb-6 font-medium text-white">
                    {benefit.flipIcon}
                  </div>
                  <p className="font-normal text-white text-2xl ">
                    {benefit.scripture}
                  </p>
                  <div
                    className="cursor-pointer right-6 absolute bottom-6"
                    onClick={() => toggleCard(benefit.order)}
                  >
                    <CloseIcon />
                  </div>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center h-full">
                  <div className="flex gap-4 w-full font-medium">
                    {benefit.topIcon}
                    <p className="font-medium mt-1 text-lg">
                      {benefit.title}
                    </p>
                  </div>
                  <p className="my-2 flex-grow font-thin text-gray-600 text-sm">
                    {benefit.description}
                  </p>
                  <div
                    className="cursor-pointer flex w-full justify-end"
                    onClick={() => toggleCard(benefit.order)}
                  >
                    {benefit.bottomIcon}
                  </div>
                </div>
              )}
            </div>

          );
        })}
      </div>
    </div>
  );
};

export default BenefitsOfCBR;
